(function (angular) {
	'use strict';

	var stateOfResidencyModalObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			address: '<',
			editAddressUrl: '@',
			show: '='
		},
		controller: [
			'mixpanelFactory',
			'urlFactory',
			StateOfResidencyModalFunction
		],
		controllerAs: 'stateOfResidencyModal'
	};

	angular
		.module('stateOfResidencyModalModule')
		.component('stateOfResidencyModal', stateOfResidencyModalObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/state-of-residency-modal/state-of-residency-modal.html';
	}

	function StateOfResidencyModalFunction(
		mixpanelFactory,
		urlFactory) {
		
		var stateOfResidencyModal = this;
		
		function stateOfResidencyUpdateViewed(afterUpdateViewedFunction) {
			urlFactory.postPromise('/account/overview/viewed-update-address-modal').then(function() {
				afterUpdateViewedFunction();
			}, function() {
				afterUpdateViewedFunction();
			});
		}
		
		stateOfResidencyModal.$onInit = function(){
			stateOfResidencyModal.currentYear = (new Date()).getFullYear();
			toggleModal();
		};

		stateOfResidencyModal.$onChanges = function(){
			toggleModal();
		};

		function toggleModal() {
			stateOfResidencyModal.modalOpen = stateOfResidencyModal.show;

			if(stateOfResidencyModal.modalOpen) {
				mixpanelFactory.track('State of Residency Modal Shown');
			}
		}
		
		stateOfResidencyModal.close = function(){
			stateOfResidencyUpdateViewed(function() {
				stateOfResidencyModal.modalOpen = false;
			});
		};
		
		stateOfResidencyModal.update = function(){
			stateOfResidencyUpdateViewed(function() {
				urlFactory.redirect(stateOfResidencyModal.editAddressUrl);
			});
		};
	}
})(window.angular);